import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import Chat from './Chat'
import { CONTENT_TYPES } from './constants'

/**
 * Specialized component for stand alone Freddie Mac guideline chat url
 */
function FreddieMacChat({ fromLanding = true }) {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.FREDDIE })
        dispatch({ type: 'SHOW_PDF', data: false }) 
    }, [dispatch])

    return <Chat fromLanding={fromLanding} />
}

export default FreddieMacChat
